<template>
	<div>
		<panel class="border border-secondary rounded mb-4" :noButton="true" v-if="getRecordedCondition">
			<template slot="header">
				<h5>Duplikat Kondisi Mobil Dari Work Order Sebelumnya</h5>
			</template>

			<b-form-row>
				<b-form-group label="Pilih Work Order" class=" col-12">
					<Multiselect 
						:options="copyList.map(x => x.form_code)"
						v-model="selected"
					/> 
				</b-form-group>
			</b-form-row>

			<b-form-row v-if="selected"> 
				<b-form-group class="col-12">
					<button class="btn btn-outline-primary" @click="confirmDuplication">
						{{!processing ? 'Konfirmasi Duplikasi Kondisi Mobil' : 'Loading...'}}
					</button>
				</b-form-group>
			</b-form-row>
		</panel>
		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Kendaraan</h5>
			</template>

			<b-form-row id="car" v-if="skip">
				<b-form-group label="Nomor Polisi Mobil" class=" col-12">
					<input
						id="registration"
						type="text"
						class="form-control"
						v-model="data.registration"
					/>
					<p v-if="error && error.registration" style="color:red">
						{{ error.registration }}
					</p>
				</b-form-group>
			</b-form-row>

			<b-form-row id="car" v-if="!exit">
				<b-form-group
					label="Kondisi Kesehatan Accu."
					class="col-md-6 col-12"
				>
					<h6 id="car_health_accu">
						Health : {{ data.condition.accu.health }} %
					</h6>
					<custom-slider
						class="w-100"
						min="0"
						max="100"
						step="1"
						:hideLabel="true"
						raising
						v-model="data.condition.accu.health"
					/>
					<p v-if="error && error.car_health_accu" style="color:red">
						{{ error.car_health_accu }}
					</p>
				</b-form-group>
				<b-form-group
					label="Kondisi Charging Accu."
					class="col-md-6 col-12"
				>
					<h6 id="car_charging_accu">
						Charging : {{ data.condition.accu.charging }} %
					</h6>
					<custom-slider
						class="w-100"
						min="0"
						max="100"
						step="1"
						:hideLabel="true"
						raising
						v-model="data.condition.accu.charging"
					/>
					<p
						v-if="error && error.car_charging_accu"
						style="color:red"
					>
						{{ error.car_charging_accu }}
					</p>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="!exit">
				<b-form-group
					label="Km Mobil Kunjungan Terakhir"
					class="col-md-6 col-12"
				>
					<input
						type="text"
						class="form-control"
						v-if="!skip"
						disabled
						v-model="data.customer_car.last_km"
					/>
					<input
						type="text"
						class="form-control"
						v-else
						disabled
						v-model="data.last_km"
					/>
				</b-form-group>
				<b-form-group label="Km Mobil Baru" class="col-md-6 col-12">
					<input
						id="car_current_km"
						type="text"
						v-if="!skip"
						class="form-control"
						v-model="data.customer_car.current_km"
					/>
					<input
						id="car_current_km"
						type="text"
						v-else
						class="form-control"
						v-model="data.current_km"
					/>
					<p v-if="error && error.car_current_km" style="color:red">
						{{ error.car_current_km }}
					</p>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group label="Bensin" class="col-12" v-if="!exit">
					<input
						type="text"
						disabled
						class="form-control"
						v-model="data.condition.fuel"
					/>
				</b-form-group>
				<!-- 				
				<b-form-group label="Indikator Bensin Pas Masuk" class="col-6" v-if="exit">
					<input type="text" disabled class="form-control" v-model="previousCheckingCondition.condition.fuel"/>
				</b-form-group> -->
				<b-form-group
					label="Bensin Sekarang"
					class="col-12"
					v-if="exit"
				>
					<input
						type="text"
						disabled
						class="form-control"
						v-model="data.condition.fuel"
					/>
				</b-form-group>
				<b-form-group class="col-12">
					<custom-slider
						class="w-100"
						:values="sliderValues"
						raising
						v-model="data.condition.fuel"
					/>
				</b-form-group>
				<b-form-group label="Permintaan Customer" class="col-12">
					<input
						type="text"
						class="form-control"
						v-model="customerRequest"
					/>
				</b-form-group>
			</b-form-row>
		</panel>

		<div class="row">
			<div class="col-md-6 col-0"></div>
			<div class="col-md-3 col-6">
				<button
					type="button"
					class="btn btn-danger w-100 rounded"
					@click="backPage()"
					v-if="typeof exit != 'boolean'"
				>
					Sebelumnya
				</button>
			</div>
			<div class="col-md-3 col-6">
				<button
					type="button"
					class="btn btn-primary w-100 rounded"
					@click="nextPage()"
					:disabled="apiLoading"
				>
					Berikutnya
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import CustomSlider from "vue-custom-range-slider";
import "vue-custom-range-slider/dist/vue-custom-range-slider.css";
import moment from 'moment'
export default {
	components: {
		Multiselect,
		CustomSlider
	},
	data() {
		return {
			error: null,
			copyList : [],
			selected : null,
			customerRequest: "",
			processing : false,
			sliderValues: [
				{
					label: "Kosong",
					value: "E"
				},
				{
					label: "1/8",
					value: "1/8"
				},
				{
					label: "1/4",
					value: "1/4"
				},
				{
					label: "3/8",
					value: "3/8"
				},
				{
					label: "1/2",
					value: "1/2"
				},
				{
					label: "5/8",
					value: "5/8"
				},
				{
					label: "3/4",
					value: "3/4"
				},
				{
					label: "7/8",
					value: "7/8"
				},
				{
					label: "Penuh",
					value: "F"
				}
			]
		};
	},
	props: [
		"page",
		"data",
		"checklistSettings",
		"exit",
		"title",
		"previousCheckingCondition",
		"skip", 
		'apiLoading',
		'getRecordedCondition'
	],
	watch: {
		"data.customer_car.current_km": function() {
			const result = this.data.customer_car.current_km
				.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => (this.data.customer_car.current_km = result));
		},
		customerRequest: function() {
			this.$emit("emitCQ", this.customerRequest);
		}
	},
	mounted() {
		if (this.getRecordedCondition) {
			this.loadCopyList()
		}

		if (this.exit)
			this.data.condition.fuel = this.previousCheckingCondition.condition
				.fuel
				? this.previousCheckingCondition.condition.fuel
				: this.data.condition.fuel;
	},
	methods: {
		async confirmDuplication () {
			try {
				this.processing = true
				let responseSource = await this.$http.get(`/api/v1/workorder/${this.selected}/detail`)

				let woConditionSource = responseSource.data.data.condition
				console.log(woConditionSource)
				console.log(this.data.form_code)

				if(	!woConditionSource.accu || 
					!woConditionSource.fuel || 
					!woConditionSource.figureOverall ||
					!woConditionSource.figure ||
					!woConditionSource.checklist
				) {
					throw new Error('Condition in this workorder is not complete. please use other Work Order')
				}

				if(this.data.form_code){
					let responseDuplication = await this.$http.patch('/api/v1/workorder/' + this.data.form_code, {	data : {
							condition : woConditionSource,
							conditionChecked : true,
							skip : false
						}	
					})
					
				}
				else {
					let processedData = JSON.parse(JSON.stringify(this.data))
					processedData.customer.ktp = processedData.customer.ktp.split(" ").join("")

					delete processedData.customer_car.brand
					delete processedData.customer_car.type
					delete processedData.customer.created_at
					delete processedData.customer.last_date
					delete processedData.customer_car.colour
					delete processedData.customer_id
					delete processedData.customer_car.model
					delete processedData.customer_car.current_km
					delete processedData.customer_car.last_km
					
					processedData.finishDate = new moment().format('Y-MM-DD')
					
					
					processedData.check_by = this.$store.state.userData.userData.name
					processedData.condition = woConditionSource
					processedData.conditionChecked = true
					processedData.skip = false

					let responseDuplication = await this.$http.post('/api/v1/workorder', {	data : processedData
					})

					this.data.form_code = responseDuplication.data.data.form_code
				}
				this.processing = false
				this.$store.dispatch('triggerAlert' , [true , 'Duplication of condition is complete.'])
				this.$router.push({
					name: "WorkOrderDetailV2",
					params: { type: "wo" },
					query: { wo: this.data.form_code }
				});

				

			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , err ,'Something Went Wrong.'])
				this.processing = false
			}
			

		},
		loadCopyList () {
			this.$http.get('/api/v1/workorder/listing/copy-condition-list?chassis_number=' + this.data.customer_car.chassis_number)
			.then((resp) => {
				let data = resp.data.data

				this.copyList = data.filter(x => x.form_code != this.data.form_code)


			})
			.catch((err) => {
				console.log(err)
			})
		},
		backPage() {
			this.$emit("backPage");
		},
		async nextPage() {
			if (await this.validate()) {
				this.$emit("nextPage", null);
			}
		},
		validate() {
			var valid = true;
			var error = {};
			this.error = null;
			let scroll = false;
			if (this.exit) return valid;

			if (!this.exit && this.data.condition.accu.health == "0") {
				//Kondisi Kesehatan Accu. Mobil [Required]
				valid = false;
				if (!scroll) {
					this.errorScroll("car");
					scroll = true;
				}
				this.errorStyleText("car_health_accu");
				error.car_health_accu =
					"Kondisi kesehatan accu. mobil wajib terisi";
			} else {
				error.car_health_accu = null;
				this.revertStyleText("car_health_accu");
			}

			if (!this.exit && this.data.condition.accu.charging == "0") {
				//Kondisi Charing Accu. Mobil [Required]
				valid = false;
				if (!scroll) {
					this.errorScroll("car");
					scroll = true;
				}
				this.errorStyleText("car_charging_accu");
				error.car_charging_accu =
					"Kondisi charging accu. mobil wajib terisi";
			} else {
				error.car_charging_accu = null;
				this.revertStyleText("car_charging_accu");
			}

			if (!this.skip) {
				if (
					!this.exit &&
					(this.data.customer_car.current_km == "" ||
						this.data.customer_car.current_km == null)
				) {
					//KM Mobil Baru [Required]
					valid = false;
					if (!scroll) {
						this.errorScroll("car");
						scroll = true;
					}
					this.errorStyle("car_current_km");
					error.car_current_km = "Km mobil baru wajib terisi";
				} else if (!this.exit) {
					error.car_current_km = null;
					this.revertStyle("car_current_km");
				}
			} else {
				if (
					this.data.current_km == "" ||
					this.data.current_km == null
				) {
					valid = false;
					if (!scroll) {
						this.errorScroll("car");
						scroll = true;
					}
					this.errorStyle("car_current_km");
					error.car_current_km = "Km mobil baru wajib terisi";
				}
				else if (isNaN(this.data.current_km)) {
					valid = false;
					if (!scroll) {
						this.errorScroll("car");
						scroll = true;
					}
					this.errorStyle("car_current_km");
					error.car_current_km = "Km mobil harus angka!";
				}
				console.log(this.data.registration.match('([A-Za-z0-9]{1,4}) ([0-9]{1,5})(\s|-)*([A-Za-z]{0,3})'))
				if (
					this.data.registration == "" ||
					this.data.registration == null
				) {
					valid = false;
					if (!scroll) {
						this.errorScroll("car");
						scroll = true;
					}
					this.errorStyle("registration");
					error.registration = "Nomor Polisi wajib terisi";
				}
				else if (!this.data.registration.match('([A-Za-z0-9]{1,4}) ([0-9]{1,5})(\s|-)*([A-Za-z]{0,3})')) {
					valid = false;
					if (!scroll) {
						this.errorScroll("car");
						scroll = true;
					}
					this.errorStyle("registration");
					error.registration = "Nomor Polisi Tidak Valid. Mohon Input Sebagai Contoh Berikut 'B 1111 KKK'";
				}
			}

			this.error = error;
			return valid;
		},
		errorScroll(id) {
			document.getElementById(id).scrollIntoView({
				behavior: "smooth"
			});
		},
		errorStyleText(id) {
			var elem = document.getElementById(id);
			var css = { color: "red" };
			Object.assign(elem.style, css);
		},
		revertStyleText(id) {
			var elem = document.getElementById(id);
			var css = { color: "black" };
			Object.assign(elem.style, css);
		},
		errorStyle(id) {
			var elem = document.getElementById(id);
			var css = { border: "1px solid red" };
			Object.assign(elem.style, css);
		},
		revertStyle(id) {
			var elem = document.getElementById(id);
			var css = { border: "1px solid #d5dbe0" };
			Object.assign(elem.style, css);
		}
	}
};
</script>
